export interface Category {
  name: string;
  nameEn: string;
  nameDe: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    nameEn: 'Shoes',
    nameDe: 'Schuhe',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20designer%20sneaker%20displayed%20on%20warm%20terracotta%20clay%20background%2C%20single%20shoe%20product%20photography%2C%20dramatic%20soft%20side%20lighting%2C%20editorial%20ecommerce%20style%2C%20rich%20earthy%20tones%2C%20high%20detail%20rubber%20sole%20and%20premium%20leather%20texture&width=400&height=400&seq=cat-shoes-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'Hoodies/Sweaters',
    nameEn: 'Hoodies/Sweaters',
    nameDe: 'Hoodies/Pullover',
    url: 'https://kaspreadsheet.com/search-912/name/Hoodies.html',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodie%20hanging%20on%20rustic%20wooden%20hanger%20against%20sage%20green%20painted%20wall%2C%20soft%20morning%20light%2C%20minimalist%20streetwear%20editorial%2C%20detailed%20fleece%20fabric%20texture%2C%20warm%20natural%20aesthetic&width=400&height=400&seq=cat-hoodies-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'T-Shirts',
    nameEn: 'T-Shirts',
    nameDe: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/T-Shirts.html',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20colorful%20folded%20t-shirts%20in%20pastel%20and%20earthy%20tones%20on%20warm%20cream%20linen%20surface%2C%20top-down%20flatlay%2C%20soft%20diffused%20lighting%2C%20premium%20cotton%20texture%2C%20minimalist%20fashion%20catalog%20style&width=400&height=400&seq=cat-tshirts-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'Jackets',
    nameEn: 'Jackets',
    nameDe: 'Jacken',
    url: 'https://kaspreadsheet.com/search-914/name/Jackets.html',
    image: 'https://readdy.ai/api/search-image?query=Black%20leather%20jacket%20on%20mannequin%20against%20dark%20charcoal%20studio%20background%2C%20moody%20dramatic%20lighting%2C%20editorial%20fashion%20photography%2C%20detailed%20zipper%20hardware%20and%20leather%20grain%2C%20premium%20streetwear%20aesthetic&width=400&height=400&seq=cat-jackets-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'Pants/Shorts',
    nameEn: 'Pants/Shorts',
    nameDe: 'Hosen/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Pants.html',
    image: 'https://readdy.ai/api/search-image?query=Folded%20denim%20jeans%20and%20cargo%20shorts%20arranged%20on%20warm%20sand%20beige%20background%2C%20top-down%20flatlay%2C%20soft%20natural%20lighting%2C%20detailed%20stitching%20and%20denim%20texture%2C%20minimalist%20fashion%20editorial&width=400&height=400&seq=cat-pants-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'Headwear',
    nameEn: 'Headwear',
    nameDe: 'Kopfbedeckungen',
    url: 'https://kaspreadsheet.com/search-916/name/Headwear.html',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20premium%20baseball%20caps%20and%20knit%20beanies%20on%20olive%20green%20background%2C%20clean%20flatlay%20arrangement%2C%20soft%20lighting%2C%20detailed%20embroidery%20and%20knit%20texture%2C%20streetwear%20accessories%20editorial&width=400&height=400&seq=cat-headwear-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'Sets',
    nameEn: 'Sets',
    nameDe: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Sets.html',
    image: 'https://readdy.ai/api/search-image?query=Matching%20hoodie%20and%20jogger%20tracksuit%20set%20displayed%20on%20blush%20pink%20background%2C%20flatlay%20with%20neatly%20folded%20pieces%2C%20soft%20studio%20lighting%2C%20premium%20fabric%20texture%2C%20coordinated%20streetwear%20fashion%20editorial&width=400&height=400&seq=cat-sets-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'Underwear/Underpants',
    nameEn: 'Underwear/Underpants',
    nameDe: 'Unterwäsche',
    url: 'https://kaspreadsheet.com/search-918/name/Underwear.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20boxer%20briefs%20and%20socks%20neatly%20arranged%20on%20soft%20grey%20background%2C%20minimal%20flatlay%2C%20clean%20diffused%20lighting%2C%20luxury%20basics%20aesthetic%2C%20detailed%20elastic%20waistband%20texture&width=400&height=400&seq=cat-underwear-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'Jersey',
    nameEn: 'Jersey',
    nameDe: 'Trikots',
    url: 'https://kaspreadsheet.com/search-919/name/Jersey.html',
    image: 'https://readdy.ai/api/search-image?query=Professional%20football%20jersey%20in%20deep%20red%20and%20gold%20displayed%20on%20warm%20amber%20background%2C%20flatlay%2C%20soft%20lighting%2C%20detailed%20breathable%20mesh%20fabric%2C%20sportswear%20editorial%20photography&width=400&height=400&seq=cat-jersey-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'Accessories',
    nameEn: 'Accessories',
    nameDe: 'Accessoires',
    url: 'https://kaspreadsheet.com/search-920/name/Accessories.html',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20watch%2C%20sunglasses%20and%20leather%20wallet%20arranged%20on%20dark%20brown%20wooden%20surface%2C%20moody%20elegant%20lighting%2C%20detailed%20metal%20and%20leather%20textures%2C%20premium%20accessories%20flatlay%20editorial&width=400&height=400&seq=cat-accessories-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'Bags',
    nameEn: 'Bags',
    nameDe: 'Taschen',
    url: 'https://kaspreadsheet.com/search-921/name/Bags.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20backpack%20and%20crossbody%20bag%20on%20light%20taupe%20background%2C%20studio%20product%20photography%2C%20soft%20lighting%2C%20detailed%20leather%20texture%20and%20metal%20hardware%2C%20minimalist%20fashion%20editorial&width=400&height=400&seq=cat-bags-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'Belts',
    nameEn: 'Belts',
    nameDe: 'Gürtel',
    url: 'https://kaspreadsheet.com/search-922/name/Belts.html',
    image: 'https://readdy.ai/api/search-image?query=Coiled%20genuine%20leather%20belts%20with%20polished%20metal%20buckles%20on%20deep%20brown%20background%2C%20elegant%20flatlay%2C%20dramatic%20soft%20lighting%2C%20detailed%20leather%20grain%2C%20premium%20accessories%20editorial&width=400&height=400&seq=cat-belts-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'Perfumes',
    nameEn: 'Perfumes',
    nameDe: 'Parfums',
    url: 'https://kaspreadsheet.com/search-923/name/Perfumes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20amber%20liquid%20on%20black%20marble%20surface%2C%20dramatic%20moody%20lighting%2C%20luxury%20fragrance%20editorial%2C%20soft%20reflections%2C%20premium%20beauty%20aesthetic&width=400&height=400&seq=cat-perfumes-v2&orientation=squarish&nocache=true',
  },
  {
    name: 'Other Stuff',
    nameEn: 'Other Stuff',
    nameDe: 'Sonstiges',
    url: 'https://kaspreadsheet.com/search-924/name/Other.html',
    image: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20assorted%20fashion%20lifestyle%20items%20including%20socks%2C%20keychain%2C%20phone%20case%20and%20scarf%20on%20warm%20neutral%20background%2C%20top-down%20flatlay%2C%20soft%20lighting%2C%20eclectic%20streetwear%20editorial&width=400&height=400&seq=cat-other-v2&orientation=squarish&nocache=true',
  },
];